//This file is automatically rebuilt by the Cesium build process.
export default "/**\n\
 * The automatic GLSL constant for {@link Pass#CESIUM_3D_TILE}\n\
 *\n\
 * @name czm_passCesium3DTile\n\
 * @glslConstant\n\
 *\n\
 * @see czm_pass\n\
 */\n\
const float czm_passCesium3DTile = 4.0;\n\
";
